import Error from '../model/Error';
import MemberApplication from '../dto/MemberApplication';
import axios from 'axios';

export default class MemberApplicationRepository {
    static getCountAndMemberApplicationsByClubIdAndFilters(clubId, status, sort, limit, offset, filters) {
        return Promise.all([
            this.countByClub(clubId, status, filters),
            this.findByClub(clubId, status, sort, limit, offset, filters),
        ]);
    }

    static findByClub(clubId, status, sort, limit, offset, filters) {
        let query = `?status=${status}${sort === null ? '' : `&sort=${sort}`}`;
        if (limit !== null) {
            query += `&limit=${limit}&offset=${offset}`;
        }
        query += this.buildFilterQuery(filters);
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/member-applications${query}`)
                .then((response) => resolve(response.data.data.map((application) => MemberApplication.fromData(application))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static countByClub(clubId, status, filters) {
        const query = `?status=${status}${this.buildFilterQuery(filters)}`;
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/member-applications/count${query}`)
                .then((response) => resolve(response.data.data.count))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static buildFilterQuery(filters) {
        if (!filters) {
            return '';
        }
        let query = '';
        (filters.departmentIds || []).forEach((id) => {
            query += `&departmentIds[]=${encodeURIComponent(id)}`;
        });
        if (filters.source) {
            query += `&source=${encodeURIComponent(filters.source)}`;
        }
        if (filters.type) {
            query += `&type=${encodeURIComponent(filters.type)}`;
        }
        return query;
    }

    static rejectApplication(applicationId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/member-applications/${applicationId}/reject`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static acceptApplication(applicationId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/member-applications/${applicationId}/accept`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
